// removed by extract-text-webpack-plugin
module.exports = {"flex":"src-pages----page-module---flex---HxH_T","page":"src-pages----page-module---page---vIddo","projectPage":"src-pages----page-module---projectPage---3Y-MS","projectPageTitle":"src-pages----page-module---projectPageTitle---2znlH","blogSpan":"src-pages----page-module---blogSpan---1wSvu","blogPosts":"src-pages----page-module---blogPosts---2e0Mn","projectContainer":"src-pages----page-module---projectContainer---Akwbh"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/page.module.css
// module id = 53
// module chunks = 212839066777427 213720915766396 263791100135453